import { Keys } from "@pdfking/tfunc"

/** The packages documented under /docs/<slug>/, in sidebar order — each
 * @pdfking/<slug>, with its import: what its examples' imports load. */
export const PACKAGES = {
  tfunc: () => import("@pdfking/tfunc"),
  structs: () => import("@pdfking/structs"),
  errors: () => import("@pdfking/errors"),
  math: () => import("@pdfking/math"),
  taskmaker: () => import("@pdfking/taskmaker"),
  planner: () => import("@pdfking/planner"),
  pdfengine: () => import("@pdfking/pdfengine"),
}

export type PackageSlug = keyof typeof PACKAGES

export const SLUGS = Keys(PACKAGES) as PackageSlug[]
